import { PaymentMode } from '@checkout/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { PAYMENT_MODE_LIST } from '../checkout-state';

export const LOAD_PAYMENT_MODE_LIST = '[Checkout] Load payment mode list';
export const LOAD_PAYMENT_MODE_LIST_SUCCESS = '[Checkout] Load payment mode list success';
export const LOAD_PAYMENT_MODE_LIST_FAIL = '[Checkout] Load payment mode list fail';
export const LOAD_PAYMENT_MODE_LIST_RESET = '[Checkout] Load payment mode list reset';

export const SET_PAYMENT = '[Checkout] Set payment mode';
export const SET_PAYMENT_FAIL = '[Checkout] Set payment mode fail';
// сбросить выбранный способ оплаты на сервере
export const DELETE_PAYMENT = '[Checkout] Delete payment mode';
export const DELETE_PAYMENT_FAIL = '[Checkout] Delete payment mode fail';
// сбросить выбранный способ оплаты на клиенте в сторе
export const RESET_PAYMENT = '[Checkout] Reset payment mode';

// запрос на перенаправление на страницу привязки новой карты
export const INIT_CARD_BINDING = '[Checkout] Init card binding';

export class LoadPaymentModeList extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_PAYMENT_MODE_LIST;

  constructor() {
    super(PAYMENT_MODE_LIST);
  }
}

export class LoadPaymentModeListSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_PAYMENT_MODE_LIST_SUCCESS;

  constructor(public payload: PaymentMode[]) {
    super(PAYMENT_MODE_LIST);
  }
}

export class LoadPaymentModeListFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_PAYMENT_MODE_LIST_FAIL;

  constructor(public payload: unknown) {
    super(PAYMENT_MODE_LIST, payload);
  }
}

export class LoadPaymentModeListReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_PAYMENT_MODE_LIST_RESET;

  constructor() {
    super(PAYMENT_MODE_LIST);
  }
}

export class SetPayment implements Action {
  readonly type = SET_PAYMENT;

  constructor(public payload: string) {}
}

export class SetPaymentFail implements Action {
  readonly type = SET_PAYMENT_FAIL;
}

export class DeletePayment implements Action {
  readonly type = DELETE_PAYMENT;
}

export class DeletePaymentFail implements Action {
  readonly type = DELETE_PAYMENT_FAIL;
}

export class ResetPayment implements Action {
  readonly type = RESET_PAYMENT;
}

export class InitCardBinding implements Action {
  readonly type = INIT_CARD_BINDING;
}

export type PaymentActions =
  | LoadPaymentModeList
  | LoadPaymentModeListSuccess
  | LoadPaymentModeListFail
  | LoadPaymentModeListReset
  | SetPayment
  | SetPaymentFail
  | DeletePayment
  | DeletePaymentFail
  | ResetPayment;
